import React from 'react';
import { compose } from 'redux';
import ConversationPage from 'view/unified-help-center/conversation-page';
import { ErrorPage } from 'view/unified-help-center/error-page';
import Layout from 'view/unified-help-center/layout';
import { CONVERSATION_PATH, ScreenName } from '@atlassian/help-center-common-component/constants';
import withOnlyAtlassianAccount from '@atlassian/help-center-common-component/with-only-atlassian-account';
import { withOnlyLoggedIn } from '@atlassian/help-center-common-component/with-only-logged-in';

const Error = () => <ErrorPage />;

const ConversationHomePage = () => {
    const WrappedComponent = compose(
        withOnlyLoggedIn({ redirectUrl: '/' }),
        withOnlyAtlassianAccount()
    )(() => <Layout renderError={Error} component={ConversationPage} screenName={ScreenName.CONVERSATION_PAGE} />);
    return <WrappedComponent />;
};

export const viewConversationPageRoute = {
    name: ScreenName.CONVERSATION_PAGE,
    path: CONVERSATION_PATH,
    exact: true,
    component: ConversationHomePage,
};
